export default {
  workshop_home_last_update: "Last update",
  workshop_home_resp_admin: "Administrative",
  workshop_home_resp_client: "Client",
  workshop_home_resp_workshop: "Workshop",
  workshop_quotations_table_date: "Date",
  workshop_quotations_table_type: "Type",
  workshop_quotations_table_value: "Value",
  workshop_quotations_table_status: "Status",
  workshop_quote_attachments_title: "Attachments and Documents",
  workshop_quote_attachments_tab: "Attachments",
  workshop_quote_invoices_tab: "Invoices",
  workshop_quote_add_attachment_btn: "Add Attachment",
  workshop_quote_add_invoice_btn: "Add Invoice (PDF)",
  workshop_quote_search_label: "Equipment ID or Name",
  workshop_quote_search_placeholder: "Enter equipment ID or name...",
  workshop_quote_finance_summary: "Financial Summary",
  workshop_quote_total_items_label: "Total Items ($)",
  workshop_quote_discount_label: "Discount ($)",
  workshop_quote_total_final_label: "Final Total ($)",
  workshop_quote_form_no_equip_msg: "No equipment added to the budget",
  workshop_quote_form_add_item_btn: "Add Item",
  workshop_quote_form_table_qty: "Qty",
  workshop_quote_form_table_item: "Code - Name",
  workshop_quote_item_type_part: "Part",
  workshop_quote_item_type_service: "Service",
  workshop_quote_modal_items_title: "Add Items to Service",
  workshop_quote_modal_search_label: "Search by name or code",
  workshop_quote_modal_search_placeholder: "Ex: CTAT001 or Screw",
  workshop_quote_modal_no_items: "No items found",
  workshop_quote_overlay_normal_price: "Normal price",
  workshop_quote_overlay_promo_price: "Promotional price",
  workshop_search_initial_msg: "Enter what you want to seek",
  workshop_search_found_companies: "Companies Found",
  workshop_search_no_companies: "No companies found",
  workshop_search_found_quotes: "Quotes Found",
  workshop_search_no_quotes: "No quotes found",
  workshop_search_query_placeholder: "company or cnpj",
  workshop_search_num_placeholder: "quote no.",
  workshop_respond_id_not_found: "Estimate ID not found",
  workshop_respond_load_error: "Error loading estimate data",
  workshop_respond_services_load_error: "Error loading services catalog",
  workshop_respond_empty_item_warning: "Add at least one item to the response",
  workshop_respond_sent_msg: "Response sent successfully!",
  workshop_respond_success_alert: "Success sending response",
  workshop_respond_send_error: "Error sending response",
  workshop_respond_no_estimate_loaded: "No estimate loaded",
  workshop_respond_no_items_msg: "No items requested",
  workshop_respond_obs_label: "Additional observation",
  workshop_respond_obs_placeholder: "Enter the response...",
  workshop_respond_total_value_label: "Total Value",
  workshop_respond_finish_btn: "Finish Response",
  workshop_respond_item_details_title: "Item Details",
  workshop_respond_select_service_title: "Select Service",
  workshop_respond_filter_label: "Filter services",
  workshop_respond_filter_placeholder: "Search by name or code...",
  workshop_respond_quantity_label: "Quantity",
  workshop_respond_add_btn: "Add Item",
  workshop_respond_client_data_title: "CLIENT DATA",
  workshop_respond_estimate_data_title: "ESTIMATE DATA",
  workshop_respond_admin_reply_title: "ADMIN RESPONSE",
  workshop_equipaments_title: "Equipment List",
  workshop_equipaments_add_btn: "Add",
  workshop_equip_add_load_equip_error: "Could not load equipment data",
  workshop_equip_add_load_services_error: "Could not load services list",
  workshop_equip_details_download_error: "Error downloading the file",
  workshop_equip_details_history_title: "Revision History",
  workshop_equip_details_id_not_found: "Equipment ID not found",
  workshop_equip_details_item_data_title: "Item Data",
  workshop_equip_details_last_photos_title: "Latest Equipment Photos",
  workshop_equip_details_load_error: "Error loading equipment data",
  workshop_equip_details_loading_msg: "Loading...",
  workshop_equip_details_loading_short_msg: "Loading...",
  workshop_equip_details_no_data_msg: "Equipment data not available.",
  workshop_equip_details_try_again_btn: "Try Again",
  workshop_home_clients_btn: "Clients",
  workshop_home_equip_not_found: "Equipment not found",
  workshop_home_load_error: "Could not load dashboard data",
  workshop_home_loading_msg: "Loading data...",
  workshop_home_no_data_msg: "No data found for this status",
  workshop_home_operation_phases: "Operation Phases",
  workshop_home_refresh_btn: "Refresh",
  workshop_home_reports_btn: "Reports",
  workshop_home_responsible_label: "Responsible",
  workshop_home_search_btn: "Search",
  workshop_home_search_btn_main: "Search",
  workshop_home_search_cnpj_nota_label: "Search by CNPJ or invoice number",
  workshop_home_search_cnpj_nota_placeholder: "Type the CNPJ or invoice number",
  workshop_home_search_note_pending_msg: "CNPJ search is active. Invoice search will be enabled after backend update on Home.",
  workshop_home_search_equip_btn_main: "Search Equipment",
  workshop_home_search_equip_label: "Enter equipment ID:",
  workshop_home_search_equip_title: "Search Equipment",
  workshop_home_select_status: "SELECT A STATUS",
  workshop_home_table_client: "Client",
  workshop_home_table_cnpj: "CNPJ",
  workshop_home_table_code: "Code",
  workshop_home_table_created: "Created",
  workshop_home_table_type: "Type",
  workshop_quotations_confirm_btn: "Yes, continue",
  workshop_quotations_create_btn: "Create Record",
  workshop_quotations_create_warning: "By proceeding, you will create a new record not linked to any estimate. Are you sure you want to continue? (to create a linked record, do this from estimate details)",
  workshop_quotations_finished_title: "Completed",
  workshop_quotations_load_error: "Could not load quotations",
  workshop_quotations_loading_msg: "Loading...",
  workshop_quotations_no_finished_msg: "No completed records",
  workshop_quotations_no_ongoing_msg: "No records in progress",
  workshop_quotations_no_pending_msg: "No pending records",
  workshop_quotations_ongoing_title: "In Progress",
  workshop_quotations_page_title: "Quotations",
  workshop_quotations_pending_title: "Pending with Me",
  workshop_quotations_table_local: "Location",
  workshop_quotations_table_ref: "Ref",
  workshop_quote_anexo_deleted_msg: "Attachment deleted successfully",
  workshop_quote_delete_anexo_title: "Delete attachment?",
  workshop_quote_delete_nota_title: "Delete invoice?",
  workshop_quote_equip_added_warning: "Equipment already added to the budget",
  workshop_quote_form_items_title: "Budget Items",
  workshop_quote_form_save_btn: "Save Budget",
  workshop_quote_form_tech_label: "Technician/Responsible",
  workshop_quote_generate_confirm_btn: "Yes, generate budget",
  workshop_quote_generate_title: "Generate Budget",
  workshop_quote_generate_warning: "This will generate a budget for administrative approval. Make sure all parts and procedures were included. Do you want to proceed?",
  workshop_quote_no_equip_error: "Add at least one equipment item to the budget",
  workshop_quote_no_service_linked: "This equipment has no linked service",
  workshop_quote_nota_deleted_msg: "Invoice deleted successfully",
  workshop_quote_remove_equip_title: "Remove equipment?",
  workshop_quote_remove_item_title: "Remove item?",
  workshop_quote_save_error: "Could not save the budget",
  workshop_quote_save_success: "Budget saved successfully!",
  workshop_quote_service_not_found: "Service not found",
  workshop_status_approved: "Approved for Maintenance",
  workshop_status_finished: "Status finished",
  workshop_status_in_analysis: "Equipment Under Analysis",
  workshop_status_pending_approval: "Status pending approval",
  workshop_status_ready: "Ready for Pickup",
  workshop_status_refused: "Status refused",
  workshop_status_waiting_equip: "Waiting for Equipment",
  workshop_status_waiting_inspection: "Waiting for Inspection and Report",
  workshop_status_waiting_invoice: "Waiting for Billing",
  workshop_status_waiting_quote: "Status waiting quote",
  workshop_breadcrumb_quotations: "Quotations",
  workshop_breadcrumb_quote: "Budget",
  workshop_breadcrumb_estimate_respond: "Estimate Response",
  workshop_breadcrumb_search: "Search",
  workshop_breadcrumb_add_equipment: "Add Equipment",
  workshop_status_sent: "Sent",
  workshop_home_table_header_actions: "Actions",
  workshop_home_mark_sent_btn: "Mark as Sent",
  workshop_home_mark_sent_confirm_title: "Confirm",
  workshop_home_mark_sent_confirm_text: "Do you want to move this item to Sent?",
  workshop_home_mark_sent_success: "Status updated to Sent.",
  workshop_home_mark_sent_error: "Could not update status to Sent.",
  workshop_status_authorize_maintenance: "Authorize Maintenance",
  workshop_home_authorize_maintenance_btn: "Authorize Maintenance",
  workshop_home_authorize_maintenance_confirm_title: "Confirm",
  workshop_home_authorize_maintenance_confirm_text: "Do you want to move this item to Authorize Maintenance?",
  workshop_home_authorize_maintenance_success: "Status updated to Authorize Maintenance.",
  workshop_home_authorize_maintenance_error: "Could not update status to Authorize Maintenance.",
  workshop_home_approve_maintenance_btn: "Approve for Maintenance",
  workshop_home_approve_maintenance_confirm_title: "Confirm",
  workshop_home_approve_maintenance_confirm_text: "Do you want to move this item to Approved for Maintenance?",
  workshop_home_approve_maintenance_success: "Status updated to Approved for Maintenance.",
  workshop_home_approve_maintenance_error: "Could not update status to Approved for Maintenance.",
  // Quick Company + Quotation Modal
  workshop_home_equip_entry_btn: "Equipment Entry",
  workshop_quick_title: "Equipment Entry — Quick Registration",
  workshop_quick_step_company: "Company",
  workshop_quick_step_quotation: "Quotation",
  workshop_quick_cnpj: "CNPJ",
  workshop_quick_company_name: "Company Name",
  workshop_quick_responsible: "Responsible Name",
  workshop_quick_email: "Responsible Email",
  workshop_quick_phone: "Phone",
  workshop_quick_schema_preview: "Schema (auto-generated)",
  workshop_quick_tipo: "Type",
  workshop_quick_choice_subtitle: "Choose how to start the service",
  workshop_quick_choice_existing: "Existing Company",
  workshop_quick_choice_existing_desc: "Select an already registered company",
  workshop_quick_choice_new: "New Company",
  workshop_quick_choice_new_desc: "Quickly register a new client",
  workshop_quick_select_company: "Select the company",
  workshop_quick_continue: "Continue",
  workshop_quick_observacoes: "Observations",
  workshop_quick_observacoes_placeholder: "Additional observations (optional)...",
  workshop_quick_local: "Execution Location",
  workshop_quick_equip_service_title: "Equipment and Service",
  workshop_quick_equipment: "Equipment",
  workshop_quick_service: "Service",
  workshop_quick_select_placeholder: "Select...",
  workshop_quick_details_title: "Details",
  workshop_quick_quantity: "Quantity",
  workshop_quick_model: "Model",
  workshop_quick_brand: "Brand",
  workshop_quick_problem: "Problem / Need",
  workshop_quick_problem_placeholder: "Describe the problem or need...",
  workshop_quick_cancel: "Cancel",
  workshop_quick_next: "Register Company and Continue",
  workshop_quick_finish: "Create Quotation and Finish",
  workshop_quick_creating: "Processing...",
  workshop_quick_company_success: "Company created successfully!",
  workshop_quick_quotation_success: "Quotation created successfully!",
  workshop_quick_error_missing: "Please fill in all required fields.",
  workshop_quick_error_exists: "Company group already exists.",
  workshop_quick_error_invalid: "Invalid name for schema.",
  workshop_quick_error_email_exists: "This e-mail already exists and cannot be registered.",
  workshop_quick_error_generic: "An error occurred. Please try again.",
}
